import React from 'react';
import { useIntl } from 'umi';
import { SelectMultiple, BubbleContent } from 'tea-component';
import { isEmpty } from '@intelligence/v3/utils/common';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import IconDom from '@/pages/intelligence/components/SelectCompoenet/ItemDom/IconDom';

import './index.scss';

interface IVisualMetricSelectorDualProps {
  // Metrics 选项
  options: any[];
  // 组件是否禁用状态
  disabled: boolean;
  // 选中的 metric 值（最多2个）
  values: string[];
  // 更改 metric values（按 options 顺序排序后返回）
  onChange: (values: string[]) => void;
}

export const renderButtonUI = (formatMessage: Function, selectedOptions?: any[]) => {
  if (isEmpty(selectedOptions)) {
    return <span className="dbi-metric-result-placeholder">{formatMessage({ id: 'dbi_please_select' })}</span>;
  }

  return selectedOptions.map((selectedOption, selectedOptionIndex) => {
    const selectedOptionKey = `${selectedOption?.value}__${selectedOption?.text}`;
    return (
      <>
        <span style={{ color: '#000' }} className="dbi-metric-result-span" key={selectedOptionKey}>
          {selectedOption?.text}
        </span>
        {selectedOptionIndex !== selectedOptions.length - 1 && <>,&nbsp;</>}
      </>
    );
  });
};

const VisualMetricSelectorDual = (props: IVisualMetricSelectorDualProps) => {
  const { options = [], values = [], onChange, disabled } = props;

  const { formatMessage } = useIntl(); // 中英切换方法

  const sortOrderArray = (arr: string[] = [], orderArr: any[] = []) => {
    return orderArr?.reduce((acc: string[], t: any) => {
      const matchingVals = arr?.filter((arrVal) => arrVal === t?.value);
      return acc.concat(matchingVals);
    }, []);
  };

  const optionValueSet = new Set(options?.map((o: any) => o?.value));
  const filteredValues = (values || []).filter((v) => optionValueSet.has(v));

  const handleChange = (nextValues: string[]) => {
    // 仅保留当前 options 中存在的值，并限制最多两个
    const filteredNext = (nextValues || []).filter((v) => optionValueSet.has(v));
    const limited = filteredNext.slice(0, 2);
    onChange?.(sortOrderArray(limited, options));
  };

  const firstOptionValue = options?.[0]?.value;
  const handleOpenChange = (visible: boolean) => {
    if (!visible) {
      // 关闭下拉时，如无选择则默认选中第一项
      if (!filteredValues?.length && firstOptionValue) {
        onChange?.([firstOptionValue]);
      }
    }
  };

  const optionsSelect = options?.map((e: any) => {
    const isDisabled = filteredValues?.length > 1 && !filteredValues?.includes(e?.value);
    const selectedIndex = filteredValues?.indexOf(e?.value);
    const isSelected = selectedIndex > -1;

    return {
      value: e?.value,
      text: (
        <div style={{ color: '#000' }}>
          <IconDom
            data={{
              text: formatMessage({ id: e?.text || e?.value }),
              img: getDataSourceIcon(e?.icon ? e.icon : e?.dataSource || e?.value),
            }}
          />
        </div>
      ),
      // 勾选2个值时，其他指标不让勾选
      disabled: isDisabled,
      tooltip: isDisabled ? (
        <BubbleContent placement="bottom-start" dark>
          <span>{formatMessage({ id: 'dbi_info_all_metrics_disabled' })}</span>
        </BubbleContent>
      ) : null,
    };
  });

  return (
    <SelectMultiple
      className="dbi-trends-metric-card-selector"
      overlayClassName="dbi--allmetric-overlay"
      options={optionsSelect}
      disabled={disabled}
      appearance="button"
      matchButtonWidth
      value={filteredValues}
      staging={false}
      onChange={handleChange}
      onOpenChange={handleOpenChange}
      button={(selectedOptions: any[]) => (
        <div className="dbi-metric-result">
          <div className="dbi-metric-result-lable">
            {formatMessage({ id: 'dbi_label_visualization_metrics' })}
          </div>
          <div className="dbi-metric-result-text">
            <div className="dbi-metric-result-value">
              {renderButtonUI(formatMessage, selectedOptions)}
            </div>
          </div>
        </div>
      )}
    />
  );
};

export default VisualMetricSelectorDual;
